import { ListingTypeBox } from './ListingTypeBox'

export default ListingTypeBox
